import React, { Suspense, useState, useEffect } from "react";
import systemListingService from "./SystemListingServices";
import { MechanicalRateDrawer } from "../../AssetLinking/MenuDrawer";
import Pagination from "components/Common/newPagination";
import { Filter } from "filter";


export default function MechanicalRate(param: any) {

  let [mechRateCount, SetmechRateCount] = useState(0);
  let [clientZones, SetclientZones] = useState<any>([]);
  let [searchZone, setSearchZone] = useState<string>("");
  let [systemFormat, SetsystemFormat] = useState<any>([]);
  let [editingOn, setEditingOn] = useState<boolean>(false);
  let [mechRateListing, SetmechRateListing] = useState<any>([]);
  let [searchFormatCode, setSearchFormatCode] = useState<string>("");

  useEffect(() => {

    if (param.activeTab === "Mechanical Rate") {
      systemListingService.getAllClientZones({}).then((res:any) => {
        SetclientZones(res)
      })
      systemListingService.systemFormatsList().then((res:any) => {
        SetsystemFormat(res)
      })
    }
  }, [param])


  var payload = {
    pageNumber: 1,
    pageSize: 10,
    format: searchFormatCode,
    territoryCode: searchZone
  }

  const mechRateSelect = () => {
    mechRateListing = [];
    SetmechRateListing(mechRateListing)

    mechRateCount = 0

    systemListingService.MechanicalRateCount(payload).then((res:any) => {

      if (res > 0) {
        mechRateCount = res
        SetmechRateCount(mechRateCount)
        systemListingService.MechanicalRateListing(payload).then((res:any) => {
          mechRateListing = res;
          SetmechRateListing(mechRateListing)
        })
      }
    })
  }

  const onPageChange = (e: any) => {
    console.log(e)
    payload.pageNumber = e.pageNumber;
    payload.pageSize = e.pageSize;
    mechRateSelect();
  }

  const openAddDrawer = () => {

  }

  return (
    <div className="content-card ws-12">

      <div className="card-header-row ws-12">
        <div className="card-title">Mechanical Rate</div>
        <div className="card-header-actions">
          <span className="pt mt">
            {mechRateCount ? mechRateCount : 0} record(s) found
          </span>
          <button className="icon-btn info" id="editModeBtn" type="button" onClick={() => setEditingOn((prev) => !prev)}   >
            {editingOn ? "Edit Mode: On" : "Edit Mode: Off"}
          </button>
        </div>
      </div>

      <div className="filter-row ws-12">

        <div className="filter-input-row ws-9" style={{ display: "flex", gap: 16, alignItems: "flex-end", flexWrap: "wrap", }}  >
          <div style={{ flex: 1, minWidth: 220 }}>

            <label style={{ fontWeight: 600, fontSize: 13 }}>Format/Source Codes</label>

            <select className="form-input" value={searchFormatCode} onChange={(e) => setSearchFormatCode(e.target.value)} >
              <option value="">Select Format/Source Codes</option>
              {systemFormat.map((opt: any) => (
                <option key={opt.formatDesc} value={opt.formatDesc}>
                  {opt.formatDesc}
                </option>
              ))}
            </select>

          </div>

          <div style={{ flex: 1, minWidth: 220 }}>
            <label style={{ fontWeight: 600, fontSize: 13 }}>  Zone </label>
            <select className="form-input" value={searchZone} onChange={(e) => setSearchZone(e.target.value)}>
              <option value="">Select Zone</option>
              {clientZones.map((opt: any) => (
                <option key={opt.zoneID} value={opt.zoneID}>
                  {opt.zoneID}
                </option>
              ))}
            </select>
          </div>

        </div>

        <div className="ptl mt">
          <button type="button" className="icon-btn primary m2 pbl" onClick={openAddDrawer}> ⊕ Add Mech Rate  </button>
          <button type="button" className="icon-btn primary m2 pbl" onClick={() => mechRateSelect()}>🔍 Search  </button>
        </div>

      </div>

      <div className="ws-12">

        <div className="allowHscroll">
          {mechRateCount > 0 && <table className="newTable ">
            <thead>
              <tr className="forceSingleLine">
                <th >Exch Rate</th>
                <th style={{ width: "20%" }}>Fixed Rate</th>
                <th >Format/Source</th>
                <th >Home Rate1</th>
                <th >Home Rate2</th>
                <th >PerMinThereafter</th>
                <th >PerSubscriber</th>
                <th >PercRevenue</th>
                <th >Rate Based on</th>
                <th >Sub Format</th>
                <th>Zone</th>
                <th >Date Up To</th>
                <th style={{ width: "19%" }}>Operation</th>
              </tr>
            </thead>
            <tbody>
              {mechRateListing.map((rate: any) => (
                <tr >
                  <td>{rate.exchRate}</td>
                  <td>{rate.fixedRate}</td>
                  <td>{rate.formatCode}</td>
                  <td>{rate.homeRate1}</td>
                  <td>{rate.homeRate2}</td>
                  <td>{rate.perMinThereafter}</td>
                  <td>{rate.perSubscriber}</td>
                  <td>{rate.percRevenue}</td>
                  <td className="forceSingleLine">{rate.rateBasedon}</td>
                  <td>{rate.subFormat}</td>
                  <td>{rate.territoryCode}</td>
                  <td className="forceSingleLine">{Filter.monthAndDayYear(rate.dateUpto)}</td>
                  <td style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }}>

                    <div style={{ width: '90px', whiteSpace: 'nowrap' }}>
                      <button className="icon-btn edit" title="Edit" type="button" disabled={!editingOn}  >
                        <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" >
                          <path d="M12 20h9" />
                          <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
                        </svg>
                      </button>

                      <button className="icon-btn delete" title="Delete" type="button" disabled={!editingOn}  >
                        <i className="icon-trash"> </i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>}

        </div>
        {mechRateCount === 0 && <div className="ws-12">
          <div className="alert alert-info ws-12 box" >No records to display</div>
        </div>}

        {(mechRateCount > 0 && mechRateCount > 10) && <Pagination totalRow={mechRateCount} onPageChange={onPageChange} />}
      </div>

    </div>

  );
};